import cn from 'classnames';
import React from 'react';

export interface FilterItemWrapperProps {
  highlight: boolean;
  children: React.ReactNode;
}

export const FilterItemWrapper = ({
  highlight,
  children,
}: FilterItemWrapperProps) => {
  return (
    <div
      className={cn('p-2 rounded-md cursor-pointer select-none h-10', {
        'bg-royal-100': highlight,
      })}
    >
      {children}
    </div>
  );
};
